import { css } from '@emotion/react';
import { hexToRgba } from '../helpers';
import { darkThemeStyle, theme } from '../theme';
import { tokens } from '../tokens';
export const linkStaticStyle = css({
    '&:hover': {
        backgroundColor: theme.background.hover,
    },
    backgroundColor: hexToRgba(tokens.colors.white, 0.01),
    borderRadius: tokens.borderRadius.medium,
    boxDecorationBreak: 'clone',
    color: theme.text.link,
    display: 'inline',
    fontFamily: tokens.fontFamilies.sansSerif,
    fontSize: 'inherit',
    fontWeight: tokens.fontWeights.bold,
    lineHeight: 'inherit',
    outline: 0,
    textDecoration: 'underline',
    textDecorationColor: 'transparent',
    textDecorationThickness: '1.25px',
    transition: 'box-shadow 125ms ease-out, background-color 125ms ease-out, text-decoration-color 125ms ease-out',
});
export function linkStyle({ inverted, isFocusVisible, size, }) {
    return [
        ...(inverted ? [darkThemeStyle] : []),
        linkStaticStyle,
        css(Object.assign(Object.assign({}, (size !== 'inherit' && {
            fontSize: tokens.fontSizes[size],
            lineHeight: tokens.lineHeights.relaxed,
        })), (isFocusVisible
            ? {
                boxShadow: `0 0 0 2px ${theme.border.focusOutline}`,
            }
            : {
                '&:hover': {
                    boxShadow: `0 0 0 2px ${theme.background.hover}`,
                    textDecorationColor: theme.text.link,
                },
            }))),
    ];
}
export const iconStyle = css({
    marginTop: '-2px',
    verticalAlign: 'middle',
});
export function innerContentStyle({ hasLeftIcon, hasRightIcon, iconSize, }) {
    const gap = iconSize === 'small' ? '2px' : tokens.spacing.xsmall;
    return css(Object.assign(Object.assign({}, (hasLeftIcon && { paddingLeft: gap })), (hasRightIcon && { paddingRight: gap })));
}
